
import {React, useContext, useState, useEffect } from "react";
import { Outlet } from "react-router";
//import Sidebar from "../../components/Sidebar";
import { ApolloClient, InMemoryCache, ApolloProvider } from '@apollo/client';
import { useQuery, gql } from '@apollo/client';
import UserContext from '../../../../context/UserContext';
import ThemeContext from "../../../../context/ThemeContext";
import { Link, useNavigate } from "react-router-dom";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from "primereact/button"; 
import { Paginator } from 'primereact/paginator';
import "../../../../index.css"
//import HtlHotelRoomTypeEdit from './HtlHotelRoomTypeEdit'
//import AgencyCreateCoop from './AgencyCreateCoop'
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import {IntlProvider, FormattedMessage, FormattedNumber, useIntl} from 'react-intl'
import messages from '../../../../lang/LangGlb';
import HtlHotelRoomTypeCreate from "./HtlHotelRoomTypeCreate";

import { locale, addLocale, updateLocaleOption, updateLocaleOptions, localeOption, localeOptions } from 'primereact/api';
        




//theme
import "primereact/resources/themes/tailwind-light/theme.css";     
    
//core
import "primereact/resources/primereact.min.css";                                       
        


const GET_POST = gql`
  query GetFilteredFirms($resType: String) {
    tbl_customer(order_by: { id_seq: desc }, where: { ACTIVE: { _eq: "ACTIVE" } }) {
      id_seq
      name
      lastname
      COUNTRY
      REAL_TYPE
      DISARE
      MIN_PRICE
      MAX_PRICE
      CURRENCY
      CUS_SEARCH_CITY
      DEALER
      STATUS
      REC_DATE
    }
  }
`;

const GET_MAIN_DPR_M = gql`
  query MyQuery($type: String!, $firmSubCode: String) {
    tbl_user_detail(
      where: {
        user_lang: { _eq: $type },
       
       
      }
    ) {
      user_name
      name
     
    }
  }
`;

const GET_FIRM_MAIN_COOP_K = gql`
  query GetFilteredFirms(
    $type: String
   
  ) {
    tbl_gnl_def(order_by: { code: asc },
      where: {
        type: { _eq: $type }
      
      }
    ) {
      code
      name
      type
      
    }
  }
`;

const GET_SUB_FIRM = gql`
  query MyQuery($type: String) {
    tbl_gnl_def(
      where: {
        type: { _eq: $type }
        
       
      }
    ) {
        code
        name
        type
    }
  }
`;

const GET_ACC_M = gql`
  query MyQuery($type: String) {
    tbl_gnl_def(
      where: {
      
        type: { _eq: $type },
      
       
      }
    ) {
      code
      name
     type
    }
  }
`;








const HtlRoomTypeList = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedPropertyType, setSelectedPropertyType] = useState('');
  const [selectedDealer, setSelectedDealer] = useState('');
  const [selecteStatus, setSelectedStatus] = useState('');
  const [selecteSCity, setSelecteSCity] = useState('');
  
  const { users } = useContext(UserContext);
  const {varCode, setVarCode} = useContext(ThemeContext);
  const {varCode2, setVarCode2} = useContext(ThemeContext);

  const userNames = users.usernames;


  const [isDisabled, setIsDisabled] = useState(false);
  
  const ownFirmMainCode = users.firmcode;
  const ownFirmSubCode = users.subfirmcode;
  const ownFirmSubType = users.userDprSub;
  const { loading, error, data, refetch } = useQuery(GET_POST, {
    variables: {
      ownFirmMainCode,
      ownFirmSubCode,
      ownFirmSubType,
    },
  });

  const navigate = useNavigate();

  
  const intl = useIntl();
  const currentLocale = users.userLang || localStorage.getItem('lang') || 'en';

  const close_form = messages[currentLocale].close_form;
  const create_room_classrec = messages[currentLocale].create_room_classrec;
  const search_by_name = messages[currentLocale].search_by_name;
  const main_code = messages[currentLocale].main_code;
  const sub_code = messages[currentLocale].sub_code;
  const room_class_code = messages[currentLocale].room_class_code;
  const room_class_name = messages[currentLocale].room_class_name;
  const int_id = messages[currentLocale].int_id;
  const currentPageReportTemplate = messages[currentLocale].currentPageReportTemplate;
  const statusrec = messages[currentLocale].statusrec;
  const detail = messages[currentLocale].detail;
  const create = messages[currentLocale].create;
  const activerec = messages[currentLocale].activerec;
  const inactiverec = messages[currentLocale].inactiverec;
  const managing_room_type = messages[currentLocale].managing_room_type;
  const administrator = messages[currentLocale].administrator;
  const dashboard = messages[currentLocale].dashboard;
  const room_class_tab = messages[currentLocale].room_class_tab;

  const items = [{ label: dashboard ,url: "/", target: '_self'}, { label: administrator  }, { label: "Customers List"  }];


  const { loading: dprmmLoading, error: dprmmError, data: dprmmData } = useQuery(GET_MAIN_DPR_M, {
    variables: { type: "en"},
  });

  const { loading: fmckloading, error: fmclerror, data: fmckData } = useQuery(GET_FIRM_MAIN_COOP_K, {
    variables: { type: "TYPE"},
  });

  const { loading: firmsLoading, error: firmsError, data: firmsData } = useQuery(GET_SUB_FIRM, {
    variables: {  type: "STATUS"},
  });

  const { loading: accmLoading, error: accmError, data: accmmData } = useQuery(GET_ACC_M, {
    variables: {  type: "CITY"},
  });


  
  useEffect(() => {
    if (ownFirmSubType === 'USR') {
      setSelectedDealer(users.usernames);
      setIsDisabled(true);
    }
  }, [ownFirmSubType]);


  const souDealerItems = dprmmData && dprmmData.tbl_user_detail
  ? dprmmData.tbl_user_detail.map(item => ({
    label: item.user_name,
    value: item.user_name,
    name: item.user_name,
    }))
  : [];

  const tarPropertyTypeItems = fmckData && fmckData.tbl_gnl_def
  ? fmckData.tbl_gnl_def.map(item => ({
    label: item.name,
    value: item.code,
    name: item.name,
    }))
  : [];

  const souStatusItems = firmsData && firmsData.tbl_gnl_def
  ? firmsData.tbl_gnl_def.map(item => ({
    label: item.name,
    value: item.code,
    name: item.name,
    }))
  : [];

  const tarCitytems = accmmData && accmmData.tbl_gnl_def
  ? accmmData.tbl_gnl_def.map(item => ({
      label: item.name,
      value: item.code,
      name: item.name, 
    }))
  : [];

  
 
  
  const [displayBasic, setDisplayBasic] = useState(false);
 
  console.log(users.firmcode);

  const [rows1, setRows1] = useState(30); // rows1'i tanımlayın ve başlangıç değeri ayarlayın
const [first1, setFirst1] = useState(0); // first1'i tanımlayın ve başlangıç değeri ayarlayın

const onRowsPerPageChange = (e) => {
  setRows1(e.value); // Görünen kayıt sayısını değiştir
  setFirst1(0); // İlk sayfadan başla
};

const onPageChange = (e) => {
  setFirst1(e.first);
  setRows1(e.rows);
};

const paginatorLeft = <Button type="button" icon="pi pi-refresh" className="p-button-text" />; // paginatorLeft'i tanımlayın
const paginatorRight = <Button type="button" icon="pi pi-cloud" className="p-button-text" />; // paginatorRight'ı tanımlayın

  
  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;





const filteredFirms = data && data.tbl_customer ? data.tbl_customer.filter((firm) => {
  const fullName = `${firm.name.toLowerCase()} ${firm.lastname.toLowerCase()}`;
  const matchesSearchTerm = fullName.includes(searchTerm.toLowerCase()) ||
                            firm.id_seq === parseInt(searchTerm);
  const matchesPropertyType = selectedPropertyType ? firm.REAL_TYPE === selectedPropertyType : true;
  const matchesDealer = selectedDealer ? firm.DEALER === selectedDealer : true;
  const matchesStatus = selecteStatus ? firm.STATUS === selecteStatus : true;
  const matchesCity = selecteSCity ? firm.CUS_SEARCH_CITY === selecteSCity : true;

  return matchesSearchTerm && matchesPropertyType && matchesCity && matchesDealer && matchesStatus;
}) : [];

  const actionTemplate2 = (rowData) => {
    refetch();
    return (
      <Link to={`/htl/hotel-adm/firm/accomodation/room-type/${rowData.r_type_code}`}>
        <button
          type="button"
          title="Open details"
          className="p-1 rounded-full dark:text-gray-600 hover:dark:bg-gray-700 focus:dark:bg-gray-700"
        >
          <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
            <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z"></path>
          </svg>
        </button>
        
      </Link>
      
    );
      };
      
      const actionTemplate = (rowData) => {
        setVarCode(rowData.id_seq)
        setVarCode2("1")
        refetch();
        return (
          <Link to={`/crm/cust/cust-edit/${rowData.id_seq}`}>
            <button
              type="button"
              title="Open details"
              className="p-1 rounded-full dark:text-gray-600 hover:dark:bg-gray-700 focus:dark:bg-gray-700"
            >
              <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
                <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z"></path>
              </svg>
            </button>
            
          </Link>
          
        );
          };
          
          
          const onClick = (id_seq) => {
         //   window.location.href = `/htl/sales/price/htlagncontract/${idSeq}`;
    
        // <Route path="/htl/sales/price/htlagncontract/:id_seq" element={<HtlAgnContractEdit />} />
        setVarCode(11);
        setVarCode2("2")
        navigate(`/crm/cust/cust-edit/${id_seq}`);
    
         //navigate(`/htl/sales/price/htlagncontractnew/`);
          
         //<Link to={`/htl/sales/price/htlagncontract/${id_seq}`}></Link>
          };
    
          const onClick2 = () => {
            
           
            refetch();
          };
          
          const onHide = () => {
            setDisplayBasic(false);
            refetch();
            
          };



  const userAndCreatedAtTemplate = (rowData) => {
    return (
      <div>
        <div className="text-xs">{rowData.create_user}</div>
        <div className="text-xs">{rowData.created_at}</div>
      </div>
    );
  };

  const getStatusLabel = (rowData) => {
    const statusClass = rowData.active
      ? "text-purple-800 font-bold text-xs"
      : "text-gray-500 font-bold text-xs";
  
    return (
      <div className={statusClass}>
      {rowData.active ? (
        <FormattedMessage id={activerec} />
      ) : (
        <FormattedMessage id={inactiverec} />
      )}
    </div>
    );
  };





  function formatCurrency(value) {
    if (value == null) {
      return '';
    }
    return value.toLocaleString('en-tr');
  }


  return (

    

    
    
    
    <div className="container p-2 mx-auto sm:p-4 dark:text-gray-100">
    <div className="flex justify-between items-center">
      <nav>
        <ul className="flex border-solid mt-3 rounded-md border-b outline-1 mb-5">
          {items.map((item, index) => (
            <li key={index} className={`flex items-center m-1 ${index === items.length - 1 ? 'font-normal' : ''}`}>
              {index !== 0 && <span className={`mx-3 ${index === items.length - 1 ? '' : 'font-light'}`}> &gt; </span>}
              {item.url ? (
                <Link to={item.url}>{item.label}</Link>
              ) : (
                <span>{item.label}</span>
              )}
            </li>
          ))}
        </ul>
      </nav>
      <button onClick={() => navigate(-1)} className="flex text-violet-900 hover:text-violet-200 font-bold">
        {close_form}
      </button>
    </div>
    
  

<div>
  
<Dialog visible={displayBasic} style={{ width: '60vw' }} onHide={onHide} header={room_class_tab}>
  <div className={`modal-backdrop bg-slate-600  ${displayBasic ? 'block' : 'hidden'}`}></div>
  <div>
    <p>
    <HtlHotelRoomTypeCreate/>
    </p>
  </div>
</Dialog>
</div>
          
<div className="card flex ">      
<div className="container p-2 mx-auto ">
      <div className=" w-1/1 text-gray-950 flex gap-4">
        <input
          type="text"
          className="px-2 py-1 border rounded-md"
          placeholder={search_by_name}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />



  <Dropdown
       className="h-11 mr-10 w-56 rounded-md" // Bu satır eklenmiştir
       
       dropdownIcon={  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
       <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
       </svg>}
       value={selectedPropertyType}
       options={tarPropertyTypeItems}
       onChange={(e) => setSelectedPropertyType(e.value)}
       placeholder={"All Property Type"}
       style={{ width: '35%' }}
       showClear
       />

<Dropdown
className="h-11 mr-10 w-56 rounded-md" // Bu satır eklenmiştir

dropdownIcon={  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
<path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
</svg>}
value={selecteSCity}
options={tarCitytems}
onChange={(e) => setSelecteSCity(e.value)}
placeholder={"All Cities"}
showClear
/>

<Dropdown
       className="h-11 mr-10 w-56 rounded-md" // Bu satır eklenmiştir
       
       dropdownIcon={  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
       <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
       </svg>}
       value={selecteStatus}
       options={souStatusItems}
       onChange={(e) => setSelectedStatus(e.value)}
       placeholder={"All Status"}
       style={{ width: '35%' }}
       showClear
       />

  

 
       <Dropdown
       className="h-11 mr-10 w-56 rounded-md" // Bu satır eklenmiştir
       
       dropdownIcon={  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
       <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
       </svg>}
       value={selectedDealer}
       options={souDealerItems}
       onChange={(e) => setSelectedDealer(e.value)}
       placeholder={"All Broker"}
       style={{ width: '35%' }}
       showClear
       disabled={isDisabled}
       />
      
      

      <div className="mt-0 flex  w-full justify-end ">
      <Button
  label={"Create New Customer"}
  aria-label="Create"
  className="p-button-sm p-button-outlined bg-purple-800 hover:bg-purple-950 text-white font-semibold rounded-md"
  onClick={() => onClick(0)} 
/>
        </div>
        </div></div></div>
      <div>
      <div className="card p-3 text-sm text-right border-b border-opacity-20 dark:border-gray-700 dark:bg-gray-900">
      <DataTable
      scrollable scrollHeight="450px" loading={loading}
      value={filteredFirms}
      paginator
      responsiveLayout="scroll"
      paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
      currentPageReportTemplate="{first} to {last} of {totalRecords}"
      rows={rows1} // Bu satırı verilerinize uygun şekilde ayarlayın
      rowsPerPageOptions={[10, 20, 30, 50, 100]}
      first={first1} // Bu satırı verilerinize uygun şekilde ayarlayın
      onPage={onPageChange}
      onRowsPerPageChange={onRowsPerPageChange}
      tableStyle={{ minWidth: '50rem',  maxHeight: '40rem' }}
    >

          <Column className="font-bold text-xs" field="id_seq" style={{ textAlign: 'left', width: '7rem' }} header={"Id Seq"}></Column>
          <Column className="text-sm font-semibold" field="name" style={{ textAlign: 'left', width: '12rem' }} header={<span sortable className="font-bold text-gray-900">{"Name"}</span>}></Column>
          <Column className="text-sm font-semibold" field="lastname" style={{ textAlign: 'left', width: '12rem' }} header={<span className="font-bold text-gray-900">{"Last Name"}</span>}></Column>
          
          
          <Column field="COUNTRY"
           className="text-xs text-right" 
           header={<span className="font-bold sortable text-gray-900">{"Country"}</span>}
           style={{ textAlign: 'left', width: '8rem' }}
          >
          </Column>

          <Column field="REAL_TYPE"
           className="text-xs text-right" 
           header={<span className="font-bold sortable text-gray-900">{"Property Type"}</span>}
           style={{ textAlign: 'left', width: '15rem' }}
          >
          </Column>

          <Column field="DISARE"
           className="text-xs text-right" 
           header={<span className="font-bold sortable text-gray-900">{"Type"}</span>}
           style={{ textAlign: 'left', width: '10rem' }}
          >
          </Column>

          <Column
      field="MIN_PRICE"
      className="text-xs text-right"
      header={<span className="font-bold sortable text-gray-900">{"Min"}</span>}
      style={{ textAlign: 'left', width: '10rem' }}
      body={(rowData) => formatCurrency(rowData.MIN_PRICE)}
    />
          <Column
      field="MAX_PRICE"
      className="text-xs text-right"
      header={<span className="font-bold sortable text-gray-900">{"Max"}</span>}
      style={{ textAlign: 'left', width: '10rem' }}
      body={(rowData) => formatCurrency(rowData.MAX_PRICE)}
    />
         
          <Column field="CURRENCY"
           className="text-xs text-right" 
           header={<span className="font-bold sortable text-gray-900">{"Currency"}</span>}
           style={{ textAlign: 'left', width: '5rem' }}
          >
          </Column>

          <Column field="CUS_SEARCH_CITY"
           className="text-xs text-right" 
           header={<span className="font-bold sortable text-gray-900">{"Location"}</span>}
           style={{ textAlign: 'left', width: '10rem' }}
          >
          </Column>


         <Column field="STATUS"
           className="text-xs text-right" 
           header={<span className="font-bold sortable text-gray-900">{"Status"}</span>}
           style={{ textAlign: 'left', width: '10rem' }}
          >
          </Column>



          <Column
           field="REC_DATE"
           header={<span className="font-bold text-xs text-gray-900">{"Rec Date"}</span>}
           body={(rowData) => {
           const dateTimeString = rowData.REC_DATE;
           const dateObj = new Date(dateTimeString);
           const options = { day: 'numeric', month: 'numeric', year: 'numeric' };
           const formattedDate = `${dateObj.toLocaleDateString('en-GB', options)}`;
           // const createUser = rowData.create_user;

          return (
           <div className="text-xs">
            {formattedDate}
           </div>
            );
           }}
          style={{ textAlign: 'right', width: '6rem' }}
           />
          

       <Column field="DEALER"
           className="text-xs text-right" 
           header={<span className="font-bold sortable text-gray-900">{"Broker"}</span>}
           style={{ textAlign: 'left', width: '7rem' }}
          >
          </Column>
        
          
         <Column
            body={actionTemplate}
            header={<span className="font-bold text-gray-900">{detail}</span>}
            
            style={{ textAlign: 'center', width: '6rem' }}
            className="font-bold text-xs" 
          />
    
        </DataTable>
        
      </div>
    </div>
    </div>
 
  );
};

export default HtlRoomTypeList;


/*

const GET_POST = gql`
  query MyQuery {
    tbl_firm_main {
      firm_code
      firm_name
      firm_type
      place
      active
      create_user
    }
  }
`;

const FirmList = () => {
  const { loading, error, data } = useQuery(GET_POST);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;

  return (
    <div className="container p-2 mx-auto sm:p-4 dark:text-gray-100">
      <h2 className="mb-4 text-2xl font-semibold leading-tight">Invoices</h2>
      <div className="overflow-x-auto">
        <table className="min-w-full text-xs">
          <colgroup>
            <col />
            <col />
            <col />
            <col />
            <col />
            <col className="w-24" />
          </colgroup>
          <thead className="dark:bg-gray-700">
            <tr className="text-left">
              <th className="p-3">Firm Code #</th>
              <th className="p-3">Firm Name</th>
              <th className="p-3">Firm Type</th>
              <th className="p-3">Place</th>
              <th className="p-3 text-right">Create User</th>
              <th className="p-3">Status</th>
            </tr>
          </thead>
          <tbody>
            {data.tbl_firm_main.map((firm) => (
              <tr
                key={firm.firm_code}
                className="border-b border-opacity-20 dark:border-gray-700 dark:bg-gray-900"
              >
                <td className="p-3">
                  <p>{firm.firm_code}</p>
                </td>
                <td className="p-3">
                  <p>{firm.firm_name}</p>
                </td>
                <td className="p-3">
                  <p>{firm.firm_type}</p>
                </td>
                <td className="p-3">
                  <p>{firm.place}</p>
                </td>
                <td className="p-3 text-right">
                  <p>{firm.create_user}</p>
                </td>
                <td className="p-3 text-right">
                  <span className="px-3 py-1 font-semibold rounded-md dark:bg-violet-400 dark:text-gray-900">
                    <span>{firm.active ? "Active" : "Inactive"}</span>
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="flex-1 bg-gray-100">Ana içerik alanı </div>
    </div> 
  );
}; 

export default FirmList; */


